var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankedKeywords(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7878 44.8257H16V64.6837H30.7878V44.8257Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0007 39.7231H51.2129V64.6835H66.0007V39.7231Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3976 32.3188H33.6055V64.6838H48.3976V32.3188Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7201 24.6782L60.8142 28.9266L65.5047 29.6089L62.1145 32.9153L62.9127 37.5864L58.7201 35.3807L54.5275 37.5864L55.3257 32.9153L51.9355 29.6089L56.6217 28.9265L58.7201 24.6782Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0814 17.3164L43.1778 21.567L47.8682 22.2493L44.478 25.5579L45.2784 30.2246L41.0836 28.0211L36.8889 30.2246L37.687 25.5579L34.2969 22.2493L38.9851 21.567L41.0814 17.3164Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.136 29.6323L25.2302 33.8829L29.9206 34.5673L26.5326 37.8716L27.3308 42.5405L23.136 40.337L18.9413 42.5427L19.7416 37.8738L16.3516 34.5694L21.0398 33.885L23.136 29.6323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankedKeywords);
export default __webpack_public_path__ + "static/media/RankedKeywords.ef6955e6a047f1eb69f409de0f67aed4.svg";
export { ForwardRef as ReactComponent };